export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-closed-caption-f6f482a24476b61b4498560b96e1e8db.svg";